<div class="row">
    <div class="col-12">
        <mat-accordion class="full-data" [displayMode]="'flat'" [hideToggle]="true">
            <mat-expansion-panel class="mat-elevation-z0" [expanded]="true" [disabled]="true">
                <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
                    <mat-panel-title>
                        <h2 class="mat-subheading-1 mb-0">
                            {{ 'contribution.transfer.form' | translate }}
                        </h2>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="bg-gray-gradient pt-3 px-3 pb-5">
                    <form #formFundTransfer="ngForm" novalidate autocomplete="off" (submit)="onSubmit()">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <mat-form-field class="full-width mb-3 mb-sm-4">
                                    <mat-select name="manager" [placeholder]="'form.origin-entity' | translate" required [(ngModel)]="fundTransfer.externalTransferManager" (ngModelChange)="onManagerChange()" #fundManagerCtrl="ngModel">
                                        <mat-option *ngFor="let trader of traders" [value]="trader.id.value">
                                            {{ trader.name + ' (' + trader.nif + ')' + ' - ' + trader.cnmv }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="fundManagerCtrl.hasError('required')">
                                        {{ 'form.validation.required' | translate }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-12 col-md-6">
                                <mat-form-field class="full-width mb-3 mb-sm-4">
                                    <input name="externalTransferName" matInput [placeholder]="'form.origin-investment-name' | translate" required [(ngModel)]="fundTransfer.externalTransferName" #fundNameCtrl="ngModel" />
                                    <mat-error *ngIf="fundNameCtrl.hasError('required')">
                                        {{ 'form.validation.required' | translate }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <mat-form-field class="full-width mb-3 mb-sm-4">
                                    <input name="externalTransferISIN" matInput [placeholder]="'form.origin-isin' | translate" maxlength="12" required isin [(ngModel)]="fundTransfer.externalTransferISIN" #isinCtrl="ngModel" />
                                    <mat-error *ngIf="isinCtrl.hasError('isin') && !isinCtrl.hasError('required')">
                                        {{ 'form.validation.isin' | translate }}
                                    </mat-error>
                                    <mat-error *ngIf="isinCtrl.hasError('required')">
                                        {{ 'form.validation.required' | translate }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-12 col-md-6">
                                <mat-form-field class="full-width mb-3 mb-sm-4">
                                    <input name="externalTransferContract" matInput [placeholder]="'form.origin-code-account' | translate" required [(ngModel)]="fundTransfer.externalTransferContract" #etContractCtrl="ngModel" />
                                    <mat-error *ngIf="etContractCtrl.hasError('required')">
                                        {{ 'form.validation.required' | translate }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 mb-3 mb-sm-4">
                                <mat-form-field class="full-width no-padding-bottom" [class.mat-form-field-invalid]="fundAmountCtrl.invalid && amountTouched">
                                    <input type="hidden" name="externalTransferAmount" [min]="minimumInvestment" [(ngModel)]="fundTransfer.amount" #fundAmountCtrl="ngModel" />
                                    <input matInput #fundAmountDirective="auto-numeric" thr-auto-numeric [placeholder]="'form.amount' | translate" required [value]="initialAmount" (keyup)="onAmountChange()" (blur)="amountTouched = true" />
                                </mat-form-field>
                                <div *ngIf="amountTouched">
                                    <mat-error class="d-block mat-caption" *ngIf="fundAmountCtrl.hasError('min') && !fundAmountCtrl.hasError('required')">
                                        {{ 'form.validation.minimum-amount' | translate : { value: minimumInvestment | number: '1.0-2' } }}
                                    </mat-error>
                                    <mat-error class="d-block mat-caption" *ngIf="fundAmountCtrl.hasError('required')">
                                        {{ 'form.validation.required' | translate }}
                                    </mat-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <mat-form-field class="full-width mb-3 mb-sm-4">
                                    <mat-select name="trader" required [placeholder]="'form.origin-trader-required' | translate" [(ngModel)]="fundTransfer.externalTransferTrader" #traderRequiredCtrl="ngModel">
                                        <mat-option *ngFor="let trader of externalTraders" [value]="trader.id.value">
                                            {{ trader.name + ' (' + trader.nif + ')' }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error class="d-block mat-caption" *ngIf="traderRequiredCtrl.hasError('required')">
                                        {{ 'form.validation.required' | translate }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row justify-content-between">
                            <div class="col-6 col-sm-5 col-md-4">
                                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" (click)="onCancel()" *ngIf="showCancel">
                                    {{ 'general.cancel' | translate }}
                                </button>
                            </div>
                            <div class="col-6 col-sm-5 col-md-4 md-2">
                                <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!formFundTransfer.valid">
                                    {{ 'general.add' | translate }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>
